<template>
</template>

<script>
import store from '@/store'

export default {
	name:'ui-form',
	props:{
		model:{type:Object},
		transferModel:{type:Object},
		columns:{type:Number,default:2},
		inline:{type:Boolean,default:false},
		autosubmit:{type:Boolean,default:false},
		view:{type:Boolean,default:false},
		labelWidth:{type:Number,default:0},
		labelMinWidth:{type:Number,default:100},
		testValueButton:{type:Boolean,default:false},
		cacheKey:{type:String,default:''},
	},
	data(){
		return {
			currentLabelWidth:0,
			verifyInfos:[]
		};
	},
	created(){
		var labelWidth=0;
		if(this.labelWidth!=0){
			labelWidth=this.labelWidth;
		}
		else{
			labelWidth=this.labelMinWidth;
		}
		var cacheForm=this.readCache();
		this.$options.render = createElement => {
			var curColumnIndex=0;
			
			var rows=[];
			var items=[];
			
			this.components=[];
			
			var slots=this.$scopedSlots.default({data:this.model});
			for(var i=0;i<slots.length;i++){
				let ctl=slots[i];
				
				if(ctl.tag==null)
					continue;
				
				var initValue=(ctl)=>{
					var field=ctl.data.attrs.field;
					if(!field){
						field=ctl.data.model.expression.split('.');
						field=field[field.length-1];
					}
					ctl.field=field;
					if(this.autosubmit){
						ctl.data.attrs.autosubmit='';
					}
					if(this.view&&ctl.data.attrs.edit==null){
						if(ctl.componentOptions.propsData==null){
							ctl.componentOptions.propsData={};
						}
						ctl.componentOptions.propsData.view=true;
					}
					if(this.model[field]==null){
						var defaultVal=ctl.data.attrs.default;
						if(defaultVal==null&&ctl.data.attrs.cache!=null&&cacheForm&&cacheForm[field]!=null)
							defaultVal=cacheForm[field];
						if(defaultVal==null&&ctl.componentOptions.Ctor.options.props)
							defaultVal=ctl.componentOptions.Ctor.options.props.value.default;
						this.$nextTick(()=>{
							this.$set(this.model,field,defaultVal);
						});
					}
				};
				
				var clearValue=(ctl)=>{
					var field=ctl.data.attrs.field;
					if(!field){
						field=ctl.data.model.expression.split('.');
						field=field[field.length-1];
					}
					if(this.model[field]!=null){
						var defaultVal=ctl.data.attrs.default;
						if(defaultVal==null)
							defaultVal='';
						this.model[field]=defaultVal;
					}
				};
				
				if(ctl.data!=null&&ctl.data.model!=null){
					initValue(ctl);
					this.components.push(ctl);
				}
				else if(ctl.componentOptions&&ctl.componentOptions.children){
					var hasButton=false;
					for(var c=0;c<ctl.componentOptions.children.length;c++){
						let child=ctl.componentOptions.children[c];
						if(child.data!=null&&child.data.model!=null){
							initValue(child);
							this.components.push(child);
						}
						else if(child.tag!=null&&child.tag.slice(-9)=='ui-button'){
							if(child.componentOptions!=null/*&&child.componentOptions.propsData.type!=null*/){
								var type=child.componentOptions.propsData.type;
								if(child.componentOptions.listeners==null)
									child.componentOptions.listeners={};
								if(child.componentOptions.listeners.submit!=null){
									hasButton=true;
									child.componentOptions.listeners.click=()=>{
										if(this.validate()){
											this.updateTransferModel();
											child.componentOptions.listeners.submit();
										}
									}
								}
								else if(type=='reset'){
									child.componentOptions.listeners.click=()=>{
										for(var s=0;s<this.components.length;s++){
											clearValue(this.components[s]);
										}
									}
								}
								else if(type=='search'||child.data.attrs&&child.data.attrs['update-model']!=null){
									child.componentOptions.listeners.click=()=>{
										this.updateTransferModel();
									}
								}
							}
						}
					}
					if(hasButton&&this.testValueButton&&!this.inline){
						ctl.componentOptions.children.push(createElement('div',{
							on:{
								'contextmenu':(e)=>{
									e.preventDefault();
									this.setTestValue(true);
								},
							},
							style:{display:'inline-block',marginLeft:'15px'}
						},[createElement('ui-button',{
							props:{
								buttonType:'info'
							},
							on:{
								click:()=>{
									this.setTestValue();
								},
							}
						},'填充测试值')]));
					}
				}
				
				var type=ctl.tag.replace(/vue-component-\d.*?-/,'');
				if(type=='ui-hidden'){
					continue;
				}
				
				if(this.inline&&ctl.data.attrs){
					if(ctl.componentOptions.propsData){
						ctl.componentOptions.propsData.novalidate='';
						if(ctl.data.attrs.label)
							ctl.componentOptions.propsData.description=ctl.data.attrs.label;
					}
				}
				
				var objectColumns=1;
				var formColumns=this.inline?1:this.columns;
				if(ctl.data!=null&&ctl.data.attrs!=null&&ctl.data.attrs.columns){
					var columns=ctl.data.attrs.columns;
					if(columns=='max'){
						objectColumns=formColumns;
					}
					else{
						objectColumns=columns;
					}
				}
				else if(ctl.componentOptions&&ctl.componentOptions.Ctor.options.data&&ctl.componentOptions.Ctor.options.data().columns){
					objectColumns=ctl.componentOptions.Ctor.options.data().columns;
				}
				
				if(objectColumns>formColumns-curColumnIndex){
	            	rows.push(createElement('div',{class:'uimaker-item'},items));
	            	items=[];
	            	curColumnIndex=0;
	            }
				
				var required=false;
				if(ctl.componentOptions&&ctl.componentOptions.propsData){
					required=ctl.componentOptions.propsData.required==''&&ctl.componentOptions.propsData.view==undefined?true:false;
				}
				var labelText=ctl.data!=null&&ctl.data.attrs!=null&&ctl.data.attrs.label?ctl.data.attrs.label+'：':'';
				var width=14.2*(labelText.length-1)+13/*冒号*/+5/*右侧label预留空间*/;
				if(this.labelWidth==0&&width>labelWidth){
					labelWidth=width;
				}
				/*if(!this.inline&&items.length!=0){
					items.push(createElement('span',{class:'uimaker-space'}));
				}*/
				if(!this.inline)
					items.push(createElement('span',{class:'uimaker-label'+(required?' uimaker-required':''),style:{width:this.inline?'':this.currentLabelWidth+'px'}},labelText));
				let verifyInfoCtl;
				if(this.verifyInfos.length!=0&&ctl.field){
					let verifyInfo=this.verifyInfos.filter(c=>c.field==ctl.field);
					if(verifyInfo.length!=0){
						verifyInfoCtl=createElement('div',{class:['uimaker-verifyinfo',verifyInfo[0].valid?'valid':undefined]},[
							createElement('i',{class:['uimaker-icon',verifyInfo[0].valid?'el-icon-check':'el-icon-close']}),
							verifyInfo[0].message?createElement('div',{class:'uimaker-message'},[verifyInfo[0].message]):undefined
						]);
					}
				}
				items.push(createElement('div',{class:'uimaker-block'},[ctl,verifyInfoCtl?verifyInfoCtl:undefined]));
				curColumnIndex+=objectColumns;
			}
			this.currentLabelWidth=labelWidth;
        	rows.push(createElement('div',{class:'uimaker-item'},items));
			return createElement('div',{class:['uimaker-form',this.inline?'uimaker-form-inline':'']},rows);
		};
	},
	methods:{
		readCache(){
			if(!store.state.app.formCaches){
				return;
			}
			let tag=this.$parent.$vnode.tag;
			let type=tag.replace(/vue-component-\d.*?-/,'');
			return store.state.app.formCaches[type+this.cacheKey];
		},
		writeCache(form){
			let model={};
			for(let i=0;i<this.components.length;i++){
				let component=this.components[i];
				
				if(component.data.attrs.cache!=null){
					let val=form[component.field];
					if(component.data.attrs['cache-formatter']!=null){
						val=component.data.attrs['cache-formatter'](val);
					}
					model[component.field]=val;
				}
			}
			
			if(Object.keys(model).length!=0){
				let tag=this.$parent.$vnode.tag;
				let type=tag.replace(/vue-component-\d.*?-/,'');
				store.commit('setFormCaches',{name:type+this.cacheKey,cache:model});
			}
		},
		setVerifyInfos(arr){
			this.verifyInfos=arr;
		},
		setTestValue(onlyRequired){
			for(var i=0;i<this.components.length;i++){
				let ctl=this.components[i];
				if(ctl.componentInstance!=null&&ctl.componentInstance.setTestValue!=null&&
					(!onlyRequired||ctl.componentOptions.propsData&&ctl.componentOptions.propsData.required!=null)&&
					(!ctl.componentOptions.propsData||ctl.componentOptions.propsData.view==undefined)){
					ctl.componentInstance.setTestValue(ctl.data.attrs.label);
				}
			}
		},
		validate(){
			var isValid=true;
			for(var i=0;i<this.components.length;i++){
				let ctl=this.components[i];
				
				if(ctl.componentInstance!=null&&ctl.componentInstance.validate!=null){
					isValid=ctl.componentInstance.validate()?isValid:false;
				}
			}
			return isValid;
		},
		getTransferModel(){
			var model={};
			for(var i=0;i<this.components.length;i++){
				var component=this.components[i];
				
				var isSubmit=true;
				if(component.componentOptions.propsData&&component.componentOptions.propsData.view!=undefined)
					isSubmit=false;
				if(component.data.attrs.autosubmit!=undefined){
					if(this.model[component.field]==null||this.model[component.field]===''){
						isSubmit=false;
					}
					else{
						isSubmit=true;
					}
				}
				if(component.data.attrs.submit!=undefined)
					isSubmit=true;
				if(component.data.attrs.nosubmit!=undefined)
					isSubmit=false;
				
				if(isSubmit){
					model[component.field]=this.model[component.field];
				}
			}
			return model;
		},
		updateTransferModel(){
			var model=this.getTransferModel();
			this.writeCache(model);
			this.$emit('update:transferModel',model);
		}
	},
	mounted(){ },
}
</script>
<style scoped>
	
</style>
<style lang="scss">
.uimaker-form{
	color:#606266;font-size:14px;
	.uimaker-item{display:flex;margin-bottom:20px;}
	.uimaker-space{width:70px;}
	.uimaker-label{
		line-height:34px;text-align:right;padding-right:20px;flex-shrink:0;padding-right:10px;font-weight:bold;
		&.uimaker-required{
			position:relative;
			&:after{color:#F56C6C;content:'*';position:absolute;margin-top:3px;margin-left:0;}
		}
	}
	/*.uimaker-label.uimaker-debug{position:relative;}
	.uimaker-label.uimaker-debug:before{content:'('attr(debugtext)')';width:85px;text-align: right;position:absolute;left:0px;top:23px}*/
	.uimaker-block{
		line-height:34px;width:100%;position:relative;
		.uimaker-info{line-height:initial;line-height:1.4;display:block;}
		.uimaker-verifyinfo{
			position:absolute;width:100%;height:100%;top:0;background:#F56C6C44;display:flex;align-items:center;border-radius:4px;
			.uimaker-icon{
				color:#F56C6C;font-size:20px;right:10px;position:absolute;
			}
			&.valid{
				background:#67C23A44;
				.uimaker-icon{color:#67C23A;}
			}
			.uimaker-message{color:#ff3333;font-size:14px;margin-left:10px;font-weight:bold;display:flex;align-items:center;
				height:18px;background:#F6DBD9;padding-right:5px;}
		}
	}
	.uimaker-view{padding-left:10px;}
	
	&.uimaker-form-inline{
		display:flex;flex-wrap:wrap;
		.uimaker-item{margin:7px 0;}
		.uimaker-block{max-width:200px;margin-right:15px;white-space:nowrap;}
	}
}
</style>